/* configurator-sticky.js
   WHL Wizard Redesign: scroll-following Build Summary pane (mock v11
   "pane travel" port). When the pane is taller than the viewport,
   scrolling down pins its bottom edge (revealing the totals and CTAs)
   and scrolling up pins its top edge; when the pane fits the viewport
   it stays pinned at the top. Presentation only: no selection readers,
   no pricing, no engine-facing behavior. Gates on #q-pane so it no-ops
   on legacy markup, and no-ops while the pane is hidden (mobile widths,
   where the bottom bar owns the summary). The glide comes from the
   existing transition on .q-summary-pane .ledger in
   configurator-redesign.css. Rollback is removing this asset's script
   tag from sections/configurator-product.liquid. */
(function () {
  'use strict';
  var pane = null;
  var lastY = 0;
  var down = false;
  var PAD = 14;

  function update() {
    if (!pane) return;
    var h = pane.offsetHeight;
    if (!h) { pane.style.top = ''; return; } /* hidden (mobile widths) */
    var vh = window.innerHeight;
    if (h + PAD * 2 <= vh) { pane.style.top = PAD + 'px'; return; }
    pane.style.top = (down ? (vh - h - PAD) : PAD) + 'px';
  }

  function onScroll() {
    var y = window.scrollY;
    if (y !== lastY) { down = y > lastY; lastY = y; }
    update();
  }

  function init() {
    pane = document.getElementById('q-pane');
    if (!pane) return; /* legacy markup: nothing to do */
    lastY = window.scrollY;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(update).observe(pane);
    }
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
